import {
    MinusCircleOutlined,
    PlusOutlined,
    SearchOutlined,
    UploadOutlined,
    CaretDownFilled,
    DeleteFilled,
    SaveOutlined,
    EditOutlined,
    StarOutlined,
    StarFilled,
} from "@ant-design/icons";
import { Button, Col, Form, Input, InputNumber, Row, Select, Space, Typography, Divider, DatePicker, Table, Tooltip } from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useState, useEffect, useCallback, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../../../routes";
import FailModal from "../../../../../components/modal/failModal";

const { Title } = Typography;
const dateFormat = "DD/MM/YYYY";
const { RangePicker } = DatePicker;
const { Text } = Typography;
const { Option } = Select;

const TableNameList = (props) => {
    const navigate = useNavigate();
    const [failModal, setFailModal] = useState(false);

    const {
        //TABLELIST
        dataSource,
        editingRow,
        handleAdd,
        handleEdit,
        onSaveTable,
        handleDeleteReccord,
        statusBT,
        tableAction,
        records,
        setRecords,
        handleFavorite,
    } = props;
    const renderFavoriteButton = (record, handleFavorite) => {
        const isFavorite = record.favorite === true; // หรือ true/false ตาม data คุณ

        return (
            <Tooltip title="รายการโปรด" color={"#31343A"} key={"favorite"} placement="bottom">
                <Button
                    shape="circle"
                    
                    onClick={() => editingRow === record.key ? handleFavorite(record) : ''}
                    icon={
                        isFavorite ? (
                            <StarFilled style={{ color: "#F79009" }} />
                        ) : (
                            <StarOutlined style={{ color: "#F79009" }} />
                        )
                    }
                    style={
                        isFavorite
                            ? { backgroundColor: "#FEF1DF", border: "none" } // favorite = ดาวทึบ พื้นเหลือง
                            : { backgroundColor: "#FFFFFF", borderColor: "#F79009" } // ไม่ favorite = ขอบเหลือง พื้นขาว
                    }
                />
            </Tooltip>
        );
    };
    
    const columns = [
        {
            title: "ลำดับ",
            align: "center",
            dataIndex: "sequence",
            key: "sequence",
            width: 72,
            render: (text, record, index) => <span>{index + 1}</span>,
        },
        {
            title: "ชื่อ-นามสกุล",
            align: "center",
            dataIndex: "name",
            key: "name",
            width: 350,

            render: (name, record) => {
                if (editingRow === record.key) {
                    return (
                        <Form.Item
                            name={"name"}
                            rules={[
                                {
                                    required: true,
                                    message: "โปรดระบุ",
                                },
                            ]}
                        >
                            <Input placeholder="ระบุ" />
                        </Form.Item>
                    );
                } else {
                    return <Text>{name}</Text>;
                }
            },
        },
        {
            title: "ตำแหน่ง",
            align: "center",
            dataIndex: "position",
            key: "position",
            width: 350,

            render: (position, record) => {
                if (editingRow === record.key) {
                    return (
                        <Form.Item
                            name={"position"}
                            rules={[
                                {
                                    required: true,
                                    message: "โปรดระบุ",
                                },
                            ]}
                        >
                            <Input placeholder="ระบุ" />
                        </Form.Item>
                    );
                } else {
                    return <Text>{position}</Text>;
                }
            },
        },
        {
            title: "เบอร์โทรศัพท์ผู้ติดต่อ",
            align: "center",
            dataIndex: "phones",
            key: "phones",
            width: 350,
            render: (phones, record) => {
                if (editingRow === record.key) {
                    return (
                        <Form.List
                            name="phones"
                            rules={[
                                {
                                    validator: async (_, values) => {
                                        if (!values || values.length < 0) {
                                            return Promise.reject(new Error("โปรดระบุ"));
                                        }
                                    },
                                },
                            ]}
                        >
                            {(fields, { add, remove }, { errors }) => (
                                <>
                                    {fields.map(({ key, name, ...restField }) => {
                                        return (
                                            <>
                                                <Space key={key} style={{ display: "flex", marginBottom: 8 }} align="baseline">
                                                    <Form.Item
                                                        {...restField}
                                                        name={[name]}
                                                        rules={[
                                                            { required: true, message: "โปรดระบุ" },
                                                            // {
                                                            //     pattern: new RegExp(/([0-9])/g),
                                                            //     message: "โปรดระบุ",
                                                            // },
                                                        ]}
                                                    >
                                                        <Input />
                                                        {/* <Input maxLength={15} min={0} /> */}
                                                    </Form.Item>
                                                    <MinusCircleOutlined onClick={() => remove(name)} />
                                                </Space>
                                            </>
                                        );
                                    })}
                                    <Form.Item>
                                        <Button
                                            disabled={fields.length <= 2 ? false : true}
                                            style={{ width: 100 }}
                                            type="dashed"
                                            onClick={() => add()}
                                            block
                                            icon={<PlusOutlined />}
                                        >
                                            เพิ่ม
                                        </Button>
                                        <Form.ErrorList errors={errors} />
                                    </Form.Item>
                                </>
                            )}
                        </Form.List>
                    );
                } else {
                    return (
                        <>
                            <Text>{record.phones[0] ? record.phones[0] : ""}</Text>
                            <br />
                            <Text>{record.phones[1] ? record.phones[1] : ""}</Text>
                            <br />
                            <Text>{record.phones[2] ? record.phones[2] : ""}</Text>
                        </>
                    );
                }
            },
        },
        {
            title: "Email ผู้ติดต่อ",
            align: "center",
            dataIndex: "emails",
            key: "emails",
            width: 350,
            render: (emails, record) => {
                if (editingRow === record.key) {
                    return (
                        <Form.List
                            name="emails"
                            rules={[
                                {
                                    validator: async (_, values) => {
                                        if (!values || values.length < 0) {
                                            return Promise.reject(new Error("โปรดระบุ"));
                                        }
                                    },
                                },
                            ]}
                        >
                            {(fields, { add, remove }, { errors }) => {
                                return (
                                    <>
                                        {fields.map(({ key, name, ...restField }) => (
                                            <Space key={key} style={{ display: "flex", marginBottom: 8 }} align="baseline">
                                                <Form.Item {...restField} name={[name]} rules={[{ required: true, message: "โปรดระบุ" }]}>
                                                    <Input />
                                                </Form.Item>
                                                <MinusCircleOutlined onClick={() => remove(name)} />
                                            </Space>
                                        ))}
                                        <Form.Item>
                                            <Button
                                                disabled={fields.length <= 2 ? false : true}
                                                style={{ width: 100 }}
                                                type="dashed"
                                                onClick={() => add()}
                                                block
                                                icon={<PlusOutlined />}
                                            >
                                                เพิ่ม
                                            </Button>
                                            <Form.ErrorList errors={errors} />
                                        </Form.Item>
                                    </>
                                );
                            }}
                        </Form.List>
                    );
                } else {
                    return (
                        <>
                            <Text>{record.emails[0] ? record.emails[0] : ""}</Text>
                            <br />
                            <Text>{record.emails[1] ? record.emails[1] : ""}</Text>
                            <br />
                            <Text>{record.emails[2] ? record.emails[2] : ""}</Text>
                        </>
                    );
                }
            },
        },
        {
            title: "คำสั่ง",
            dataIndex: "sequence",
            key: "sequence",
            width: 150,
            render: (_, record) => {
                if (editingRow === record.key) {
                    return (
                        <>
                            <Space>

                                {tableAction && (
                                    <Tooltip title="แก้ไข" color={"#31343A"} key={"edit"} placement="bottom">
                                        <Button
                                            shape="circle"
                                            icon={<EditOutlined style={{ color: "#F79009" }} />}
                                            style={{ backgroundColor: "#FEF1DF", border: "none" }}
                                            onClick={() => handleEdit(record)}
                                        ></Button>
                                    </Tooltip>
                                )}
                                {!tableAction && (
                                    <Tooltip title="บันทึก" color={"#31343A"} key={"save"} placement="bottom">
                                        <Button
                                            shape="circle"
                                            style={{ backgroundColor: "#E1F5F2", border: "none" }}
                                            onClick={() => onSaveTable(record)}
                                        >
                                            <SaveOutlined style={{ color: "green" }} />
                                        </Button>
                                    </Tooltip>
                                )}
                                {/* <Tooltip title="รายการโปรด" color={"#31343A"} key={"favorite"} placement="bottom">
                                </Tooltip> */}
                                {renderFavoriteButton(record, handleFavorite)}
                                <Tooltip title="ลบ" color={"#31343A"} key={"delete"} placement="bottom">
                                    <Button
                                        shape="circle"
                                        style={{ backgroundColor: "#FDE7E5", border: "none" }}
                                        onClick={() => handleDeleteReccord(record)}
                                    >
                                        <DeleteFilled style={{ color: "#F04438" }} />
                                    </Button>
                                </Tooltip>
                            </Space>
                        </>
                    );
                } else {
                    return (
                        <>
                            <Space>
                                <Tooltip title="แก้ไข" color={"#31343A"} key={"edit"} placement="bottom">
                                    <Button
                                        shape="circle"
                                        icon={<EditOutlined style={{ color: "#F79009" }} />}
                                        style={{ backgroundColor: "#FEF1DF", border: "none" }}
                                        onClick={() => handleEdit(record)}
                                    ></Button>
                                </Tooltip>
                                {/* <Tooltip title="รายการโปรด" color={"#31343A"} key={"favorite"} placement="bottom">
                                </Tooltip> */}
                                {renderFavoriteButton(record, handleFavorite)}
                                <Tooltip title="ลบ" color={"#31343A"} key={"delete"} placement="bottom">
                                    <Button
                                        shape="circle"
                                        style={{ backgroundColor: "#FDE7E5", border: "none" }}
                                        onClick={() => handleDeleteReccord(record)}
                                    >
                                        <DeleteFilled style={{ color: "#F04438" }} />
                                    </Button>
                                </Tooltip>
                            </Space>
                        </>
                    );
                }
            },
        },
    ];

    return (
        <Content>
            <Table dataSource={dataSource} columns={columns} pagination={false}></Table>
            {statusBT != true && (
                <Button
                    onClick={() => {
                        if (editingRow !== null && editingRow !== undefined) { setFailModal(true); }
                        else { handleAdd(); }
                    }}
                    type="primary"
                    style={{ margin: "20px 0px 16px 0px", background: "#2E90FA", color: "#fff", fontWeight: 500 }}
                >
                    <PlusOutlined />
                    เพิ่ม
                </Button>
            )}
            <FailModal
                open={failModal}
                setOpen={setFailModal}
                title={"มีบางอย่างผิดพลาด"}
                subTitle={"กรุณาบันทึกข้อมูลแถวที่กำลังเพิ่มหรือแก้ไขก่อนกดเพิ่ม."}
                setErrMsg={() => setFailModal(false)}
            />
        </Content>
    );
};

export default TableNameList;
